var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(-0.027 -0.011)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 76.5,
    cy: 76.5,
    r: 76.5,
    transform: "translate(0.027 0.011)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M94.323,18.4a11.536,11.536,0,0,0-8.139-8.139C79,8.333,50.208,8.333,50.208,8.333s-28.794,0-35.976,1.925A11.542,11.542,0,0,0,6.09,18.4C4.167,25.58,4.167,45.167,4.167,45.167s0,19.585,1.923,26.767a11.542,11.542,0,0,0,8.142,8.142C21.414,82,50.208,82,50.208,82S79,82,86.184,80.076a11.528,11.528,0,0,0,8.139-8.139c1.925-7.185,1.925-26.77,1.925-26.77S96.248,25.58,94.323,18.4ZM41,61.116v-31.9L68.623,45.167Z",
    transform: "translate(26.121 29.983)",
    fill: "#273c49"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite);
export default __webpack_public_path__ + "static/media/youtube-white.87bb4d6d3388b1f892ffd710093c3b17.svg";
export { ForwardRef as ReactComponent };